export const rateDiscriminator = {
  fcl: "fcl",
  fclFlat: "fcl-flat",
  fclPickupDelivery: "fcl-pickup-delivery",
  airFlat: "air-flat",
  lcl: "lcl",
  lclFlat: "lcl-flat",
  air: "air",
  ftl: "ftl",
  ftlFlat: "ftl-flat",
  ptl: "ptl",
  ptlFlat: "ptl-flat",
  ltlPickupDelivery: "ltl-pickup-delivery",
  ltl: "ltl",
  ltlFlat: "ltl-flat",
  ltlLinked: "ltl-linked",
};
